// eslint-disable-next-line import/prefer-default-export
export const MyTasksTypes = {
  TOGGLE_MY_TASK: 'TOGGLE_MY_TASK',
};
